export default __webpack_public_path__ + "static/media/nft11.68b14792.png";